import { Box, UnorderedList, ListItem, Text } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
const SubNav = ({ links, rootPathName }) => {
    const location = useLocation();
    const { pathname } = location;
    const tokens = useTokens();
    const styles = {
        nav: {
            height: '100vh',
            pt: '108px',
            bgColor: tokens.Layer02,
            boxShadow: '4px 0px 6px 0px rgba(26, 26, 26, 0.20)',
            a: {
                _focusVisible: {
                    p: {
                        borderColor: tokens.BorderFocus,
                        borderWidth: tokens.BorderWidth01,
                        marginTop: '-1px',
                        ml: '-1px',
                    },
                },
            },
            li: {
                paddingLeft: tokens.Spacing06,
                paddingRight: tokens.Spacing06,
                paddingTop: '14px',
            },
            inactive: {
                fontWeight: tokens.TextHeadingLight6FontWeight,
                fontSize: tokens.TextHeadingLight6FontSize,
                lineHeight: tokens.TextHeadingLight6LineHeight,
                color: tokens.TextDark800,
                _hover: {
                    backgroundColor: tokens.SecondaryNavigationHover,
                },
            },
            active: {
                background: tokens.SecondaryNavigationSelected,
                fontWeight: tokens.TextBodyMedium3FontWeight,
                fontSize: tokens.TextBodyMedium3FontSize,
                lineHeight: tokens.TextBodyMedium3LineHeight,
                color: tokens.TextDark800,
                borderRightWidth: tokens.BorderWidth04,
                borderRightColor: tokens.SecondaryNavigationSelectedBar,
            },
            title: {
                borderBottomWidth: tokens.BorderWidth01,
                borderBottomColor: tokens.SecondaryNavigationSelectedBar,
                _hover: undefined,
            },
            p: {
                color: tokens.TextDark800,
                fontSize: tokens.TextHeadingLight6FontSize,
                fontWeight: tokens.TextHeadingLight6FontWeight,
                margin: '0',
            },
        },
    };
    const isRoot = !!rootPathName && location.pathname === rootPathName;
    const activeLiStyles = (option) => (isRoot && option.isDefault) || pathname.startsWith(option.to)
        ? styles.nav.active
        : styles.nav.inactive;
    const getTitleStyle = (index) => ({
        ...styles.nav.inactive,
        ...styles.nav.title,
        marginTop: index > 0 ? tokens.Spacing04 : 0,
    });
    return (React.createElement(Box, { "data-testid": "sub_nav", role: "navigation", "aria-label": "Sub Nav", sx: styles.nav },
        React.createElement(UnorderedList, { variant: "sidebar" }, links.map((link, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(RenderIf, { condition: !!link.title },
                React.createElement(ListItem, { sx: getTitleStyle(index) }, link.title)),
            link.options.map((option) => (React.createElement(ListItem, { key: option.to, sx: activeLiStyles(option) },
                React.createElement(Link, { ref: option.ref, "data-testid": option.to, to: option.to, tabIndex: 0 },
                    React.createElement(Text, null, option.label)))))))))));
};
export default SubNav;
